/* globals jQuery, createCookie, readCookie */
/* exported btCorner, $ */

var btCorner = (function btCorner($){
    'use strict';
    /* jshint ignore:start */

    function createCookie(name, value, days) {
        var expires;

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

    function readCookie(name) {
        var nameEQ = encodeURIComponent(name) + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }
    /* jshint ignore:end */

    var show,
    hide,
    activeClass,
    //addEventListenerToModal,
    //removeEventListenerFromModal,
    init,
    load,
    $modal,
    $closeBtn,
    $bottles,
    $linkWrapper,
    $trigger,
    onOpenCallback,
    onProductSelectedCallback,
    modalMarkup,
    cornerMarkup,
    COOKIE_NAME = 'bt-corner',
    COOKIE_VALUE = 'SEEN',
    COOKIE_DAYS = 999;


    cornerMarkup = '<div class="btcorner-wrap">' +
'<div class="btcorner">' +
'<div class="btcorner-corner-shadow"></div>' +
'<div class="btcorner-bg"></div>' +
'<div class="btcorner-text-discover"></div>' +
'<div class="btcorner-text-discover--over"></div>' +
'<div class="btcorner-corner-shadow1"></div>' +
'<div class="btcorner-corner"></div>' +
'</div>' +
'</div>' +
'</div>';

    modalMarkup = '<div class="btoverlay"></div><div class="btmodal">' +
'<div class="btmodal-header">' +
'<span class="js-close btmodal-close">×</span>' +
'</div>' +
'<div class="btmodal-content"><h1 class="btmodal-heading">THESE BEERS ARE \r' +
'PRESERVATIVE \r' +
'FREE AND ON \r' +
'AVERAGE \r' +
'99.9% \r' +
'SUGAR FREE!</h1><p class="btmodal-parag">Click on your favourite beer \r' +
'to discover more about its \r' +
'nutrition content.</p>' +
'</div>' +
'<div class="btmodal-links"></div>' +
'</div>';

    activeClass = 'btmodal--is-active';

    show = function(){
        $('.btoverlay').fadeIn('fast', function() {
            if (!$modal.hasClass(activeClass)){
                $modal.addClass(activeClass);
            }
            //addEventListenerToModal();
            onOpenCallback('BTBT - Beautiful Corners','Opened','');
        });
    };

    hide = function(){
        $('.btoverlay').fadeOut('fast', function() {
            //removeEventListenerFromModal();
            // if ($modal.hasClass(activeClass)){
            //     $modal.removeClass(activeClass);
            // }
            $('.btcorner-wrap, .btoverlay, .btmodal').remove();
        });

        createCookie(COOKIE_NAME, COOKIE_VALUE, COOKIE_DAYS);
    };

    /*addEventListenerToModal = function(){
        $trigger.off('click', show);
        $closeBtn.on('click', hide);
    };*/

    /*removeEventListenerFromModal = function(){
        $closeBtn.off('click', hide);
        $trigger.on('click', show);
    };*/

    load = function(dataPath){
        if(readCookie(COOKIE_NAME) === null ){
          $.getJSON(dataPath, init);
        }
    };

    init = function(config){

        $('body').append(cornerMarkup)
        .append(modalMarkup);

        $('.btoverlay').hide();

        $modal = $('.btmodal');
        $linkWrapper = $modal.find('.btmodal-links');
        $closeBtn = $('.btmodal .js-close');
        $trigger = $('.btcorner');

        //$trigger.parent().css('position', 'relative');

        switch(config.brand){
            case 'james-boags': {
                $linkWrapper.addClass('btmodal-links--james-boags');
                break;
            }

            case 'xxxx': {
                $linkWrapper.addClass('btmodal-links--xxxx');
                break;
            }

            case 'tooheys': {
                $linkWrapper.addClass('btmodal-links--tooheys');
                break;
            }

            case 'hahn': {
                $linkWrapper.addClass('btmodal-links--hahn');
                break;
            }

            default: {
                throw 'No layout available for this brand.';
            }
        }

        /*
        div.btmodal-links.btmodal-links--hahn
            a.btmodal-bottle
                img
                img
                span.btmodal-label
        */

        for(var i=0; i<config.products.length; i++){
            var img, glowImg, link;
            img = $('<img/>').attr('src', config.imagePath+config.products[i].bottle).attr('width','100%');
            glowImg = $('<img/>').attr('src', config.imagePath+config.products[i].glow).attr('width','100%');

            link = document.createElement('a');
            $.data(link, 'brand', config.brand);
            $.data(link, 'name', config.products[i].name);
            $(link).addClass('btmodal-bottle').attr('href', config.products[i].url).attr('target', '_blank');
            $(link).append(img).append(glowImg).append($('<span class="btmodal-label">Discover more</span>'));
            $linkWrapper.append(link);
        }

        $trigger.on('click', show);
        $closeBtn.on('click', hide);

        $bottles = $('.btmodal-bottle');
        $bottles.each(function(){
            $(this).on('touchstart mouseenter', function(){
                $(this).find('img:nth-child(2)').stop().fadeIn('fast');
            }).on('mouseleave', function(){
                $(this).find('img:nth-child(2)').stop().fadeOut('fast');
            }).on('click', function(e) {
                var beerName = $(this).data('brand')+' '+$(this).data('name');
                onProductSelectedCallback('BTBT - Beautiful Corners','Product Clicked', beerName);
                hide();
            });
        });
    };

    return {
        version: '1.8',
        show: show,
        hide: hide,
        init: load,
        onOpen: function(callback){
            onOpenCallback = callback;
        },
        onProductSelected: function(callback){
            onProductSelectedCallback = callback;
        }
    };
})(jQuery);
